<template>
    <div>
        <v-card-text>
            <booking-table
                preventDefault
                :items="bookings"
                :options="pagination"
                :excludeHeaders="[
                    $constant.table.BOOKING_HEADER_KEY.saleAccount,
                    $constant.table.BOOKING_HEADER_KEY.quantity
                ]"
                @viewDetails="viewBookingDetails"
                @sort="emitBookingTableSort"/>
        </v-card-text>

        <right-panel
            hideBottom
            ref="bookingDetailsPanel"
            :title="$t('bookingList.bookingDetails.header')">
            <template v-slot:content="{ context }" >
                <booking-details-view
                    :booking="context"
                    :productTableExcludeHeaders="[
                        'description',
                        'productType',
                        'status',
                        'amount',
                        'total'
                    ]"/>
            </template>
        </right-panel>
    </div>
</template>

<script>
import BookingTable from '@/components/tables/BookingTable'
import BookingDetailsView from '@/views/BookingDetailsView'
import RightPanel from '@/components/panels/RightPanel'

export default {
    name: 'BookingListView',

    components: {
        BookingTable,
        BookingDetailsView,
        RightPanel
    },

    props: {
        value: {
            type: Number,
            default: 0
        },

        bookings: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            bookingDetailDrawer: false
        }
    },

    methods: {
        viewBookingDetails (bookingItem) {
            this.$refs.bookingDetailsPanel.open(bookingItem)
        },

        emitBookingTableSort (sortBy, sortType) {
            this.$emit('booking:sort', sortBy, sortType)
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-tab {
    text-transform: none;
}
</style>
